// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__30Ljn","description":"PatientConsentPreview_description__hbuc5"};